import { Component } from '@angular/core';

@Component({
  selector: 'app-small-faq',
  imports: [],
  templateUrl: './small-faq.html',
  styleUrl: './small-faq.css',
})
export class SmallFaq {

}
